// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"87f811ee","154":"72884d20","239":"39a90afc","304":"9ab98e7f","375":"9ee92c67","455":"b917598e","554":"f33a3b30","650":"72058549","777":"ea0d02ab","779":"372ff0c5"}[chunkId] + ".chunk.css";
};